/* ============================================================
   KNIGHTSBRIDGE BEDDING — GLOBAL BEHAVIOURS
   Converted from the approved custom HTML pages. All listeners
   are delegated on document level so re-rendered markup
   (e.g. the cart drawer via the Section Rendering API) stays
   bound automatically.
   ============================================================ */
(function () {
  'use strict';

  var CART_SECTION = 'cart-drawer';

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $all(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }

  /* ============================================================
     MOBILE SIDEBAR MENU
     ============================================================ */
  function openSidebar() {
    var sb = $('#sidebar'), ov = $('#sidebarOverlay'), t = $('#menuToggle');
    if (!sb) return;
    sb.classList.add('open');
    if (ov) ov.classList.add('show');
    document.body.classList.add('sidebar-open');
    if (t) t.setAttribute('aria-expanded', 'true');
  }
  function closeSidebar() {
    var sb = $('#sidebar'), ov = $('#sidebarOverlay'), t = $('#menuToggle');
    if (!sb) return;
    sb.classList.remove('open');
    if (ov) ov.classList.remove('show');
    document.body.classList.remove('sidebar-open');
    if (t) t.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#menuToggle')) {
      e.preventDefault();
      var sb = $('#sidebar');
      if (sb && sb.classList.contains('open')) closeSidebar(); else openSidebar();
      return;
    }
    if (e.target.closest('#sidebarClose') || e.target.closest('#sidebarOverlay')) { closeSidebar(); return; }

    /* Sidebar sub-menu accordions (single open) */
    var subLink = e.target.closest('.sidebar__list .sidebar__link');
    if (subLink) {
      var li = subLink.closest('.has-sub');
      var wasOpen = li.classList.contains('open');
      $all('.sidebar__list .has-sub.open').forEach(function (o) { o.classList.remove('open'); });
      if (!wasOpen) li.classList.add('open');
      return;
    }

    /* Footer link accordions (mobile only, single open) */
    var fh3 = e.target.closest('.footer__nav h3');
    if (fh3) {
      if (window.innerWidth > 640) return;
      var nav = fh3.parentElement;
      var open = nav.classList.contains('open');
      $all('.footer__nav.open').forEach(function (n) { n.classList.remove('open'); });
      if (!open) nav.classList.add('open');
      return;
    }

    /* Back to top visibility button */
    if (e.target.closest('#toTop')) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeSidebar(); closeCart(); closeSheet(); }
  });

  /* Back to top visibility */
  var toTop = $('#toTop');
  if (toTop) {
    window.addEventListener('scroll', function () {
      toTop.classList.toggle('show', window.scrollY > 600);
    }, { passive: true });
  }

  /* ============================================================
     CART DRAWER — real Shopify cart (AJAX + Section Rendering)
     ============================================================ */
  var cartLastFocus = null;

  function openCart() {
    var d = $('#cartDrawer'), ov = $('#cartOverlay');
    if (!d) return;
    cartLastFocus = document.activeElement;
    d.classList.add('open');
    if (ov) ov.classList.add('show');
    document.body.classList.add('cart-open');
    var c = $('#cartClose'); if (c) c.focus();
  }
  function closeCart() {
    var d = $('#cartDrawer'), ov = $('#cartOverlay');
    if (!d) return;
    d.classList.remove('open');
    if (ov) ov.classList.remove('show');
    document.body.classList.remove('cart-open');
    if (cartLastFocus && cartLastFocus.focus) cartLastFocus.focus();
  }

  function updateCartCounts(count) {
    var n = parseInt(count, 10) || 0;
    $all('.cart-count').forEach(function (b) { b.textContent = n > 0 ? n : ''; });
  }

  /* Replace the rendered cart-drawer section with a fresh server render */
  function applyCartSection(html) {
    var tpl = document.createElement('div');
    tpl.innerHTML = html;
    var fresh = tpl.firstElementChild;
    var current = $('#shopify-section-' + CART_SECTION) || $('#cartDrawer');
    if (fresh && current && current.id === 'shopify-section-' + CART_SECTION) {
      current.replaceWith(fresh);
    } else if (fresh) {
      document.body.appendChild(fresh);
    }
  }

  function cartRequest(url, body) {
    body = body || {};
    body.sections = CART_SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }

  function addVariant(id, qty, btn) {
    if (!id) return Promise.resolve();
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return addItems([{ id: parseInt(id, 10), quantity: qty || 1 }], btn);
  }

  /* Multi-line add (product + upsells); shared with kb-product.js via window.KBCart */
  function addItems(items, btn) {
    if (!items || !items.length) return Promise.resolve();
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); }
    return cartRequest(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
      items: items
    }).then(function (data) {
      if (data.status) { console.error('Cart error:', data.message); return; }
      if (data.sections && data.sections[CART_SECTION]) applyCartSection(data.sections[CART_SECTION]);
      updateCartCounts(data.item_count);
      openCart();
    }).catch(function (err) { console.error(err); })
      .finally(function () { if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); } });
  }

  function changeLine(line, qty) {
    cartRequest(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
      line: line, quantity: qty
    }).then(function (data) {
      if (data.status) { console.error('Cart error:', data.message); return; }
      if (data.sections && data.sections[CART_SECTION]) applyCartSection(data.sections[CART_SECTION]);
      updateCartCounts(data.item_count);
    }).catch(console.error);
  }

  /* The header count can render stale (cached page) — always sync it on load */
  function syncCartCountOnLoad() {
    fetch(shopRoot() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { updateCartCounts(c.item_count); })
      .catch(function () { /* noop */ });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncCartCountOnLoad);
  else syncCartCountOnLoad();

  document.addEventListener('click', function (e) {
    /* Open drawer from header cart button */
    var openBtn = e.target.closest('[data-cart-toggle]');
    if (openBtn) { e.preventDefault(); openCart(); return; }

    if (e.target.closest('#cartClose') || e.target.closest('#cartOverlay')) {
      closeCart();
      return;
    }

    /* Remove inside the drawer — parent cards and nested add-on rows both
       carry data-cart-act="rm". Removing a PARENT also removes every child
       add-on tagged with its variant id: update.js takes a quantity PER LINE
       (array), built from the rendered rows with parent + children zeroed. */
    var act = e.target.closest('[data-cart-act]');
    if (act) {
      var mainVid = act.dataset.mainVariant;
      if (mainVid) {
        var countEl = $('[data-line-count]');
        var lineCount = parseInt(countEl && countEl.dataset.lineCount, 10) || 0;
        var qtyByLine = {};
        $all('[data-line-qty]').forEach(function (el) {
          qtyByLine[parseInt(el.dataset.line, 10)] = parseInt(el.dataset.lineQty, 10) || 1;
        });
        qtyByLine[parseInt(act.dataset.line, 10)] = 0;
        $all('[data-child-of="' + mainVid + '"]').forEach(function (kid) {
          var kl = parseInt(kid.dataset.childLine, 10);
          if (kl) qtyByLine[kl] = 0;
        });
        var updates = [];
        for (var li = 1; li <= lineCount; li++) updates.push(qtyByLine[li] !== undefined ? qtyByLine[li] : 1);
        cartRequest(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/update.js' : '/cart/update.js', {
          updates: updates
        }).then(function (data) {
          if (data.status) { console.error('Cart error:', data.message); return; }
          if (data.sections && data.sections[CART_SECTION]) applyCartSection(data.sections[CART_SECTION]);
          updateCartCounts(data.item_count);
        }).catch(console.error);
      } else {
        changeLine(parseInt(act.dataset.line, 10), 0);
      }
      return;
    }
  });

  /* ============================================================
     SEARCH — mobile icon toggle + predictive suggestions
     ============================================================ */
  function esc(s) {
    return String(s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function shopRoot() {
    return window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-search-toggle]');
    if (t) {
      var header = t.closest('.header');
      if (!header) return;
      var open = header.classList.toggle('search-open');
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        var i = header.querySelector('.search__input');
        if (i) i.focus();
      }
      return;
    }
    /* Click outside the form closes the suggestion dropdown */
    if (!e.target.closest('.search')) {
      $all('.search__suggest').forEach(function (b) { b.hidden = true; });
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      $all('.search__suggest').forEach(function (b) { b.hidden = true; });
      var h = $('.header');
      if (h) h.classList.remove('search-open');
      var st = $('[data-search-toggle]');
      if (st) st.setAttribute('aria-expanded', 'false');
    }
  });

  var ssTimer = null;
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.search__input');
    if (!input) return;
    var form = input.closest('.search');
    var box = form ? form.querySelector('.search__suggest') : null;
    if (!box) return;
    clearTimeout(ssTimer);
    var q = input.value.trim();
    if (q.length < 2) { box.hidden = true; box.innerHTML = ''; return; }
    ssTimer = setTimeout(function () {
      fetch(shopRoot() + 'search/suggest.json?q=' + encodeURIComponent(q) +
        '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,variants.title')
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) {
            box.innerHTML = '<div class="ss-empty">No matches for "' + esc(q) + '"</div>';
          } else {
            var html = products.map(function (p) {
              var url = p.url ? p.url.split('?')[0] : '#';
              var img = p.featured_image && p.featured_image.url ? p.featured_image.url : '';
              if (img) img += (img.indexOf('?') > -1 ? '&' : '?') + 'width=88';
              var price = p.price != null ? '£' + Number(p.price).toFixed(2) : '';
              return '<a class="ss-item" href="' + esc(url) + '">' +
                (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') +
                '<span><span class="ss-title">' + esc(p.title) + '</span>' +
                (price ? '<span class="ss-price">' + price + '</span>' : '') +
                '</span></a>';
            }).join('');
            html += '<a class="ss-all" href="' + shopRoot() + 'search?q=' + encodeURIComponent(q) + '">View all results for "' + esc(q) + '"</a>';
            box.innerHTML = html;
          }
          box.hidden = false;
        }).catch(function () {});
    }, 250);
  });

  /* ============================================================
     ANNOUNCEMENT — copy promo code
     ============================================================ */
  document.addEventListener('click', function (e) {
    var codeBtn = e.target.closest('.code-btn');
    if (!codeBtn) return;
    var code = codeBtn.dataset.code;
    var hint = codeBtn.querySelector('.code-hint');
    function done() {
      if (hint) {
        hint.textContent = 'Copied';
        setTimeout(function () { hint.textContent = 'Copy'; }, 2000);
      }
    }
    function fallback() {
      var t = document.createElement('textarea');
      t.value = code;
      t.style.position = 'fixed';
      t.style.opacity = '0';
      document.body.appendChild(t);
      t.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(t);
      done();
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done, fallback);
    } else {
      fallback();
    }
  });

  /* ============================================================
     NEWSLETTER TEASER — floating button, 2-step popup, AJAX signup
     ============================================================ */
  function nlShowStep(name) {
    var modal = $('#nlModal');
    if (!modal) return;
    $all('.nl-step', modal).forEach(function (s) {
      s.hidden = s.dataset.step !== name;
    });
  }
  function nlOpen() {
    var modal = $('#nlModal'), ov = $('#nlOverlay'), t = $('#nlTeaser');
    if (!modal) return;
    nlShowStep('1');
    modal.classList.add('open');
    if (ov) ov.classList.add('show');
    document.body.classList.add('nl-open');
    if (t) t.setAttribute('aria-expanded', 'true');
    var yes = modal.querySelector('[data-nl-next]');
    if (yes) yes.focus();
  }
  function nlClosePopup() {
    var modal = $('#nlModal'), ov = $('#nlOverlay'), t = $('#nlTeaser');
    if (!modal) return;
    modal.classList.remove('open');
    if (ov) ov.classList.remove('show');
    document.body.classList.remove('nl-open');
    if (t) t.setAttribute('aria-expanded', 'false');
    /* remember the dismissal so the auto-open doesn't nag repeatedly */
    try { localStorage.setItem('kb_nl_dismissed', String(Date.now())); } catch (err) {}
  }
  function nlHideTeaserForGood() {
    var fab = $('#nlFab');
    if (fab) fab.style.display = 'none';
    try { localStorage.setItem('kb_nl_done', '1'); } catch (err) {}
  }
  function nlDismissFab() {
    var fab = $('#nlFab');
    if (fab) fab.style.display = 'none';
    try { localStorage.setItem('kb_nl_fab_off', String(Date.now())); } catch (err) {}
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('#nlFabClose')) { nlDismissFab(); return; }
    if (e.target.closest('#nlTeaser')) { nlOpen(); return; }
    if (e.target.closest('#nlClose') || e.target.closest('[data-nl-close]') || e.target.closest('#nlOverlay')) {
      nlClosePopup();
      return;
    }
    var next = e.target.closest('[data-nl-next]');
    if (next) {
      nlShowStep('2');
      var first = $('#nlForm input[name="first_name"]');
      if (first) first.focus();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      var modal = $('#nlModal');
      if (modal && modal.classList.contains('open')) nlClosePopup();
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('#nlForm');
    if (!form) return;
    e.preventDefault();
    var err = $('#nlError');
    var name = form.querySelector('input[name="first_name"]');
    var email = form.querySelector('input[name="email"]');
    var interest = form.querySelector('input[name="interest"]:checked');
    function fail(msg) {
      if (err) { err.textContent = msg; err.hidden = false; }
    }
    if (err) err.hidden = true;
    if (!name.value.trim()) { fail('Please enter your first name.'); name.focus(); return; }
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.value.trim())) { fail('Please enter a valid email address.'); email.focus(); return; }
    if (!interest) { fail('Please pick what you are interested in.'); return; }

    var btn = form.querySelector('[data-nl-submit]');
    if (btn) btn.disabled = true;

    var fd = new FormData();
    fd.append('form_type', 'customer');
    fd.append('utf8', '✓');
    fd.append('contact[first_name]', name.value.trim());
    fd.append('contact[email]', email.value.trim());
    fd.append('contact[tags]', 'newsletter,interested:' + interest.value);

    fetch('/contact', { method: 'POST', body: fd, redirect: 'follow' })
      .then(function (res) {
        if (res.url && res.url.indexOf('customer_posted=true') > -1) return true;
        throw new Error('not posted');
      })
      .then(function () {
        nlHideTeaserForGood();
        nlShowStep('done');
        setTimeout(nlClosePopup, 3200);
      })
      .catch(function () {
        fail('Something went wrong — please try again in a moment.');
        if (btn) btn.disabled = false;
      });
  });

  /* Hide the floating button permanently once subscribed, or for 3 days
     after the visitor removed it with its own ✕ badge (page loads).
     Closing the POPUP alone never hides the button. */
  try {
    if (localStorage.getItem('kb_nl_done') === '1') {
      nlHideTeaserForGood();
    } else {
      var fabOff = parseInt(localStorage.getItem('kb_nl_fab_off') || '0', 10);
      if (Date.now() - fabOff < 3 * 24 * 60 * 60 * 1000) {
        var fabEl = $('#nlFab');
        if (fabEl) fabEl.style.display = 'none';
      }
    }
  } catch (err) {}

  /* Auto-open the popup 10s after page load — unless already subscribed,
     dismissed within the last 3 days, or another overlay is open */
  setTimeout(function () {
    try {
      if (localStorage.getItem('kb_nl_done') === '1') return;
      var dismissed = parseInt(localStorage.getItem('kb_nl_dismissed') || '0', 10);
      if (Date.now() - dismissed < 3 * 24 * 60 * 60 * 1000) return;
    } catch (err) {}
    if (document.body.classList.contains('cart-open') ||
        document.body.classList.contains('sidebar-open') ||
        document.body.classList.contains('sheet-open')) return;
    nlOpen();
  }, 10000);

  /* Current year in footer */
  var yearEl = $('#year');
  if (yearEl) yearEl.textContent = new Date().getFullYear();

  /* ============================================================
     FAQ — single-open accordion with smooth height animation
     ============================================================ */
  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.faq-item summary');
    if (!summary) return;
    e.preventDefault();
    var item = summary.parentElement;
    var answer = item.querySelector('.faq-answer');

    $all('.faq-item[open]').forEach(function (other) {
      if (other !== item) other.open = false;
    });

    if (item.open) {
      answer.style.height = answer.offsetHeight + 'px';
      answer.style.overflow = 'hidden';
      answer.style.transition = 'height .3s ease, padding .3s ease, opacity .3s ease';
      requestAnimationFrame(function () {
        answer.style.height = '0px';
        answer.style.paddingTop = '0px';
        answer.style.paddingBottom = '0px';
        answer.style.opacity = '0';
      });
      setTimeout(function () {
        item.open = false;
        answer.style.cssText = '';
      }, 310);
    } else {
      item.open = true;
      var h = answer.offsetHeight;
      answer.style.overflow = 'hidden';
      answer.style.transition = 'height .3s ease, padding .3s ease, opacity .3s ease';
      answer.style.height = '0px';
      answer.style.paddingTop = '0px';
      answer.style.paddingBottom = '0px';
      answer.style.opacity = '0';
      requestAnimationFrame(function () {
        answer.style.height = h + 'px';
        answer.style.opacity = '1';
        answer.style.paddingTop = '';
        answer.style.paddingBottom = '';
      });
      setTimeout(function () { answer.style.cssText = ''; }, 310);
    }
  });

  /* ============================================================
     PAGE-BASED CAROUSEL HELPER
     One dot per visible page (not per slide), arrows step a full
     page. Rebuilds on resize so breakpoints recalculate per-page.
  ============================================================ */
  function initPagedCarousel(track, dotsWrap, itemSel, gap) {
    var slides = $all(itemSel, track);
    if (!slides.length) return;
    var dots = [];

    function metrics() {
      var w = slides[0].getBoundingClientRect().width + gap;
      var perPage = Math.max(1, Math.round(track.clientWidth / w));
      return { step: w, perPage: perPage, pages: Math.ceil(slides.length / perPage) };
    }

    function active() {
      var m = metrics();
      var idx = Math.round(track.scrollLeft / (m.step * m.perPage));
      if (idx > m.pages - 1) idx = m.pages - 1;
      if (idx < 0) idx = 0;
      dots.forEach(function (d, i) { d.classList.toggle('active', i === idx); });
    }

    function buildDots() {
      dotsWrap.innerHTML = '';
      dots = [];
      var m = metrics();
      for (var p = 0; p < m.pages; p++) {
        (function (page) {
          var dot = document.createElement('button');
          dot.setAttribute('aria-label', 'Go to page ' + (page + 1));
          dot.addEventListener('click', function () {
            var m2 = metrics();
            var first = slides[Math.min(page * m2.perPage, slides.length - 1)];
            track.scrollTo({ left: first.offsetLeft - track.offsetLeft, behavior: 'smooth' });
          });
          dotsWrap.appendChild(dot);
          dots.push(dot);
        }(p));
      }
      active();
    }

    track.addEventListener('scroll', active, { passive: true });
    window.addEventListener('resize', buildDots);
    buildDots();

    return {
      pageStep: function (dir) {
        var m = metrics();
        track.scrollBy({ left: dir * m.step * m.perPage, behavior: 'smooth' });
      }
    };
  }

  /* ============================================================
     LIFESTYLE GALLERY SLIDER
     ============================================================ */
  function initGallery() {
    var track = $('#galleryTrack');
    var dotsWrap = $('#galleryDots');
    if (!track || !dotsWrap) return;
    var pager = initPagedCarousel(track, dotsWrap, '.gallery__slide', 10);
    var prev = $('#galleryPrev'), next = $('#galleryNext');
    if (prev) prev.addEventListener('click', function () { pager.pageStep(-1); });
    if (next) next.addEventListener('click', function () { pager.pageStep(1); });
  }

  /* ============================================================
     USP BAR — slide swap (mobile). The current item slides up out of
     view (.exit) while the next slides in from the bottom (.active).
     Pure transform, no fade.
     ============================================================ */
  function initUspBar() {
    var grid = $('.uspbar__grid');
    if (!grid) return;
    var items = $all('.usp-item', grid);
    if (!items.length) return;
    if (items.length < 2) { items[0].classList.add('active'); return; }
    var idx = 0, DUR = 650, HOLD = 3500;
    items[0].classList.add('active');
    setInterval(function () {
      var cur = items[idx];
      idx = (idx + 1) % items.length;
      var next = items[idx];
      next.classList.add('active');
      cur.classList.remove('active');
      cur.classList.add('exit');
      /* after the exit finishes, snap the old item back below the fold
         without animating, ready for its next entrance */
      setTimeout(function () {
        cur.classList.add('noanim');
        cur.classList.remove('exit');
        void cur.offsetHeight;
        cur.classList.remove('noanim');
      }, DUR + 60);
    }, HOLD);
  }

  /* ============================================================
     COLLECTION — filter sheet, filter accordions, sort,
     infinite scroll, read more, auto-apply filters on desktop
     ============================================================ */
  function openSheet() {
    var wrap = $('#filtersWrap'), ov = $('#sheetOverlay'), btn = $('#openFilters');
    if (!wrap) return;
    wrap.classList.add('open');
    if (ov) ov.classList.add('show');
    document.body.classList.add('sheet-open');
    if (btn) btn.setAttribute('aria-expanded', 'true');
  }
  function closeSheet() {
    var wrap = $('#filtersWrap'), ov = $('#sheetOverlay'), btn = $('#openFilters');
    if (!wrap) return;
    wrap.classList.remove('open');
    if (ov) ov.classList.remove('show');
    document.body.classList.remove('sheet-open');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('#openFilters');
    if (openBtn) {
      e.preventDefault();
      var wrap = $('#filtersWrap');
      if (wrap && wrap.classList.contains('open')) closeSheet(); else openSheet();
      return;
    }
    if (e.target.closest('#sheetOverlay') || e.target.closest('#filtersClose') || e.target.closest('#applyFilters')) {
      closeSheet();
      return;
    }

    /* Filter group accordions */
    var head = e.target.closest('.fgroup__head');
    if (head) {
      var group = head.parentElement;
      var collapsed = group.classList.toggle('collapsed');
      head.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
      return;
    }

    /* Collection info read more */
    var rm = e.target.closest('#readMore');
    if (rm) {
      var txt = $('#cinfoText');
      if (txt) {
        var open = txt.classList.toggle('open');
        rm.textContent = open ? 'Read Less' : 'Read More';
        rm.setAttribute('aria-expanded', open ? 'true' : 'false');
      }
      return;
    }

  });

  /* Infinite scroll — auto-load the next page when the grid end nears view.
     The next-page URL lives on #loadMoreWrap (data-next-url). Each loaded
     page's successor is prefetched into memory, so the next batch is usually
     ready before the user reaches it; new cards fade in on insert. */
  (function () {
    var wrap = $('#loadMoreWrap');
    if (!wrap || !('IntersectionObserver' in window)) return;
    var busy = false;
    var cache = {};
    function grab(url) {
      return cache[url] ? Promise.resolve(cache[url]) : fetch(url).then(function (r) { return r.text(); });
    }
    function appendCards(doc) {
      var grid = $('#productGrid');
      if (!grid) return;
      var cards = $all('#productGrid .product-card', doc);
      cards.forEach(function (c) {
        c.classList.add('is-entering');
        grid.appendChild(c);
      });
      /* single reflow starts every fade in the batch together */
      void grid.offsetHeight;
      cards.forEach(function (c) { c.classList.remove('is-entering'); });
    }
    function loadNext() {
      var url = wrap.dataset.nextUrl;
      if (!url || busy) return;
      busy = true;
      grab(url)
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          appendCards(doc);
          var newWrap = doc.querySelector('#loadMoreWrap');
          var nextUrl = newWrap && newWrap.dataset.nextUrl;
          if (nextUrl) {
            wrap.dataset.nextUrl = nextUrl;
            /* warm the cache so the following batch inserts instantly */
            fetch(nextUrl).then(function (r) { return r.text(); }).then(function (t) { cache[nextUrl] = t; }).catch(function () {});
            /* short pages can leave the wrap still in view — re-arm the
               observer so it fires again immediately if more pages remain */
            io.unobserve(wrap); io.observe(wrap);
          } else {
            delete wrap.dataset.nextUrl;
          }
        })
        .catch(console.error)
        .finally(function () { busy = false; });
    }
    var io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) { loadNext(); break; }
      }
    }, { rootMargin: '1200px 0px' });
    io.observe(wrap);
  })();

  /* Auto-apply filters on change (desktop); sheet Apply button submits on mobile */
  document.addEventListener('change', function (e) {
    if (e.target.closest('#filtersScroll')) {
      if (window.innerWidth > 1100) {
        var form = $('#filtersForm');
        if (form) form.submit();
      }
      return;
    }
    /* Sort select navigates preserving current query params */
    var sortSel = e.target.closest('#sortSelect');
    if (sortSel && sortSel.value) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', sortSel.value);
      window.location.search = params.toString();
    }
  });

  window.addEventListener('resize', function () {
    if (window.innerWidth > 1100) closeSheet();
  });

  /* Policy pages (/policies/*) — Shopify renders these with system markup
     inside our layout (the theme's templates/policy.liquid is only honoured
     once the theme is published), so the fallback is styled in critical.css
     and augmented here with a contact card. No-ops on every other page. */
  function initPolicyPage() {
    var container = document.querySelector('.shopify-policy__container');
    if (!container) return;
    document.body.classList.add('policy-page');

    var ask = document.createElement('div');
    ask.className = 'shopify-policy__ask';
    ask.innerHTML =
      '<div><h3>Questions About This Policy?</h3>' +
      '<p>If anything here is unclear, our team is happy to talk it through in plain English.</p></div>' +
      '<a class="btn btn--primary" href="/pages/contact">Contact Us</a>';
    container.appendChild(ask);
  }

  /* Init section-scoped widgets */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initGallery(); initUspBar(); initPolicyPage(); });
  } else {
    initGallery();
    initUspBar();
    initPolicyPage();
  }

  /* ============================================================
     CONTENT PROTECTION — site-wide copy deterrence: no right-click
     menu, no image drag, no text selection/copy via keyboard or
     touch. Form fields (search, cart note) stay fully usable.
     Deterrent only — view-source/DevTools cannot be truly blocked.
     ============================================================ */
  function protectionEditable(el) {
    if (!el || !el.tagName) return false;
    var t = el.tagName;
    return t === 'INPUT' || t === 'TEXTAREA' || t === 'SELECT' || el.isContentEditable === true;
  }

  document.addEventListener('contextmenu', function (e) { e.preventDefault(); });

  document.addEventListener('dragstart', function (e) {
    if (e.target && e.target.tagName === 'IMG') e.preventDefault();
  });

  document.addEventListener('copy', function (e) {
    if (!protectionEditable(e.target)) e.preventDefault();
  });

  document.addEventListener('cut', function (e) {
    if (!protectionEditable(e.target)) e.preventDefault();
  });

  document.addEventListener('keydown', function (e) {
    var k = (e.key || '').toLowerCase();
    /* devtools shortcuts */
    if (k === 'f12' || (e.ctrlKey && e.shiftKey && (k === 'i' || k === 'j' || k === 'c'))) { e.preventDefault(); return; }
    /* copy/cut/select-all/save/view-source — allowed inside form fields */
    if ((e.ctrlKey || e.metaKey) && !e.shiftKey && !protectionEditable(e.target) &&
        (k === 'c' || k === 'x' || k === 'a' || k === 's' || k === 'u')) e.preventDefault();
  });

  /* Shared cart bridge for section scripts (kb-product.js) */
  window.KBCart = { addVariant: addVariant, addItems: addItems, changeLine: changeLine, openCart: openCart, closeCart: closeCart };
})();
